'use client';

import { TrackedButton } from '@/components/button';
import { TRACKED_EVENT_NAME, TRACKED_EVENT_POSITION } from '@/constants';
import { useInquiryChat } from '@/components/channel-talk';
import { cn } from '@lib/utils';

import { heroCtaPop, pillBase, pillHoverRed } from './main-hero.constants';

const PRICE_INQUIRY_LABEL = 'main-hero_price-inquiry';

// hero 섹션은 LCP 경로라 서버 컴포넌트로 남겨야 해서, 클릭 핸들러가 필요한 이 버튼만 분리했다.
export function MainHeroInquiryCta({ text }: { text: string }) {
  const inquiryChatProps = useInquiryChat('quote');

  return (
    <TrackedButton
      eventName={TRACKED_EVENT_NAME.CTA_CLICK}
      label={PRICE_INQUIRY_LABEL}
      position={TRACKED_EVENT_POSITION.MAIN_HEADER}
      {...inquiryChatProps}
      className={cn(
        pillBase,
        heroCtaPop,
        '[--hero-cta-delay:350ms] xl:[--hero-cta-delay:715ms]',
        pillHoverRed,
        'group gap-2.5 bg-3b-blue-light-900 text-white',
      )}
    >
      {text}
      <span
        aria-hidden="true"
        className="transition-transform group-hover:translate-x-[7px]"
      >
        →
      </span>
    </TrackedButton>
  );
}
